import { CustomerUserFormPage } from "@/features/customer-user/pages/CustomerUserFormPage";

const CustomerUserEdit = () => {
  return <CustomerUserFormPage mode="edit" />;
};

export default CustomerUserEdit;
